import axios from 'axios'
import { axiosFactory, errorHandler } from '@/configs/axios'

const weather = {
  api: (payload) => {
    return axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather?lat=${payload[1]}&lon=${payload[0]}&appid=4a9971d817030a7bcc855ca3f92958dc&units=metric`
      )
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        return false
      })
  },
}

const fleetSummary = {
  api: () => {
    return axiosFactory()
      .auth.get('api/customers/v1/fleet-summary/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const carsList = {
  api: () => {
    return axiosFactory()
      .auth.get('vehicles/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const carsInfo = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('vehicles/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const imeiList = {
  api: (payload = true) => {
    return axiosFactory()
      .auth.get(`devices/summaries/?company_vehicle__isnull=${payload}`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const notUsedDrivers = {
  api: () => {
    return axiosFactory()
      .auth.get('drivers/summaries/?company_vehicle__isnull=true')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const provinceList = {
  api: () => {
    return axiosFactory()
      .auth.get('geolocations/provinces/?country=1')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const cityList = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('geolocations/cities/?province=' + payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const neighborhoodList = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('geolocations/neighborhood/?city=' + payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const colorList = {
  api: () => {
    return axiosFactory()
      .auth.get('colors/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const licenseChars = {
  api: () => {
    return axiosFactory()
      .auth.get('vehicles/license-plate-chars/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const addAddress = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('geolocations/addresses/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

const editAddress = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('geolocations/addresses/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export {
  weather,
  fleetSummary,
  carsList,
  imeiList,
  notUsedDrivers,
  provinceList,
  cityList,
  neighborhoodList,
  colorList,
  carsInfo,
  addAddress,
  licenseChars,
  editAddress,
}
